import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ProductForm from "./ProductForm";
import AddProductImages from "./AddPRoductImg";
import ProductVariantForm from "./OptionalForm";
import { addProduct } from "../../api/productService";
import { getErrorMessage } from "../../utils/errorHandler";

export default function AddProductStepper() {
  const navigate = useNavigate();
  // STEP (persisted)
  const [step, setStep] = useState(() => {
    return Number(localStorage.getItem("productStep")) || 1;
  });
  // PRODUCT ID (persisted)
  const [productId, setProductId] = useState(() => {
    return localStorage.getItem("productId") || "";
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [backendErrors, setBackendErrors] = useState({});

  useEffect(() => {
    if (productId) {
      localStorage.setItem("productStep", step);
    }
  }, [step, productId]);
  useEffect(() => {
    if (productId) {
      localStorage.setItem("productId", productId);
    }
  }, [productId]);
  const handleAddProduct = async (formData) => {
    try {
      setLoading(true);
      setBackendErrors({});

      const response = await addProduct(formData);
      if (response?.status === 422) {
        setBackendErrors(response.error);
        return;
      }
      // Check success
      if (!response?.success) {
        alert(response?.message || "Failed to create product");
        return;
      }

      const createdId = response?.data;

      setProductId(createdId);
      localStorage.setItem("productId", createdId);

      setStep(2);
      localStorage.setItem("productStep", "2");
    } catch (error) {
      console.error(error);
      alert(getErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };
  const handleImagesSuccess = (response) => {
    setStep(3);
    localStorage.setItem("productStep", "3");
  };
  const handleVariantSuccess = () => {
    setSuccess(true);
    // STOP saving effect first
    setProductId("");
    // CLEAR STORAGE
    localStorage.removeItem("productStep");
    localStorage.removeItem("productId");
    localStorage.removeItem("productForm");
    setStep(1);
    setTimeout(() => {
      navigate("/products");
    }, 2000);
  };
  return (
    <div className="container-fluid p-4">
      <div className="card shadow border-0">
        <div className="card-body">
          <h3 className="mb-4">Add Product</h3>
          {/* STEPPER */}
          <div className="d-flex justify-content-between align-items-center mb-3 position-relative">
            <div
              style={{
                position: "absolute",
                top: "22px",
                left: "8%",
                width: "82%",
                height: "4px",
                background: "#dee2e6",
                zIndex: 1,
              }}
            >
              <div
                style={{
                  width: step === 1 ? "0%" : step === 2 ? "50%" : "100%",
                  height: "100%",
                  background: "#59b71f",
                  transition: "0.3s",
                }}
              />
            </div>
            {/* STEP 1 */}
            <div
              className="text-center position-relative"
              style={{ zIndex: 2 }}
            >
              <div
                style={{
                  width: "45px",
                  height: "45px",
                  borderRadius: "50%",
                  background: step >= 1 ? "#59b71f" : "#dee2e6",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: "18px",
                  margin: "0 auto",
                }}
              >
                1
              </div>
              <p className="mt-2 mb-0">Product Details</p>
            </div>
            {/* STEP 2 */}
            <div
              className="text-center position-relative"
              style={{ zIndex: 2 }}
            >
              <div
                style={{
                  width: "45px",
                  height: "45px",
                  borderRadius: "50%",
                  background: step >= 2 ? "#59b71f" : "#dee2e6",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: "18px",
                  margin: "0 auto",
                }}
              >
                2
              </div>
              <p className="mt-2 mb-0">Upload Images</p>
            </div>
            {/* STEP 3 */}
            <div
              className="text-center position-relative"
              style={{ zIndex: 2 }}
            >
              <div
                style={{
                  width: "45px",
                  height: "45px",
                  borderRadius: "50%",
                  background: step >= 3 ? "#59b71f" : "#dee2e6",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: "18px",
                  margin: "0 auto",
                }}
              >
                3
              </div>
              <p className="mt-2 mb-0">Product Variations</p>
            </div>
          </div>
          {/* STEP 1 */}
          {step === 1 && (
            <>
              <h5 className="mb-3">Product Details</h5>
              <ProductForm
                onSubmit={handleAddProduct}
                loading={loading}
                backendErrors={backendErrors}
              />
            </>
          )}
          {/* STEP 2 */}
          {step === 2 && (
            <>
              <h5 className="mb-3">Upload Images</h5>
              <AddProductImages
                id={productId}
                onSuccess={handleImagesSuccess}
              />
            </>
          )}
          {/* STEP 3 */}
          {step === 3 && !success && (
            <>
              <h5 className="mb-3">Add Product Variations</h5>
              <ProductVariantForm
                id={productId}
                onSuccess={handleVariantSuccess}
              />
            </>
          )}
          {/* SUCCESS */}
          {success && (
            <div className="alert alert-success text-center my-4">
              Product added successfully! Redirecting...
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
